import React from 'react';
import { useTranslation } from 'react-i18next';
import { useBreakpoint } from '@panel/commons';
import { HeadbandVamx, Link } from './style';

const Headband = () => {
  const [reachedBreakPoint] = useBreakpoint(767);
  const { t } = useTranslation();

  return (
    <>
      {!reachedBreakPoint ? (
        <HeadbandVamx>
          {t('panel.header.title.headband.mobile')}
          <Link href={t('panel.header.title.headband.href')} target='_blank'>
            {t('panel.header.title.headband.mobile.1')}
          </Link>
        </HeadbandVamx>
      ) : (
        <HeadbandVamx>
          {t('panel.header.title.headband')}
          <Link href={t('panel.header.title.headband.href')} target='_blank'>
            {t('panel.header.title.headband.1')}
          </Link>
        </HeadbandVamx>
      )}
    </>
  );
};
export { Headband };
